// extracted by mini-css-extract-plugin
module.exports = {"container":"CardContainer_container__1qo6l","title":"CardContainer_title__3pOZ7","subTitle":"CardContainer_subTitle__2m-Hv"};